import { createReducer, on } from "@ngrx/store";
import { ProductsState } from "./products.state";
import { GiftCardsProductsActions, SubscriptionsProductsActions } from "./products.actions";
import { SubscriptionPlan } from "app/models/subscrition-plan.model";


const initialProductsState: ProductsState = {
    giftsCardsState: { giftsCardsProducts: [], loading: false },
    subscriptionsState: { subscriptionsProducts: [], loading: false },
    optionsState: { optionsProducts: [], loading: false },
}

export const ProductsReducer = createReducer<ProductsState>(
    initialProductsState,
    // GIFT CARDS PLANS
    on(GiftCardsProductsActions.getGiftCardsProducts, (state): ProductsState => {
        return {
            ...state,
        }
    }),
    on(GiftCardsProductsActions.setGiftCardsProducts, (state, { giftCardsProducts }): ProductsState => {
        return {
            ...state,
            giftsCardsState: { giftsCardsProducts: giftCardsProducts, loading: false },
        }
    }),

    // SUBSCRIPTIONS PLANS
    on(SubscriptionsProductsActions.getSubscriptionsProducts, (state): ProductsState => {
        return {
            ...state,
        }
    }),
    on(SubscriptionsProductsActions.setSubscriptionsProducts, (state, { subscriptionsProducts }): ProductsState => {
        return {
            ...state,
            subscriptionsState: { subscriptionsProducts: subscriptionsProducts.filter((subscriptionProduct: SubscriptionPlan) => subscriptionProduct.name !== 'family'), loading: false },
            optionsState: { optionsProducts: subscriptionsProducts.filter((subscriptionProduct: SubscriptionPlan) => subscriptionProduct.name === 'family'), loading: false },
        }
    })
)